import script from "./ReportErrorIconButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportErrorIconButton.vue?vue&type=script&setup=true&lang=ts"

import "./ReportErrorIconButton.vue?vue&type=style&index=0&id=28cb1378&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28cb1378"]])

export default __exports__